import { useEffect, useState } from 'react';

import { Button, CSS, designTokens, Flex } from '@project44/manifest-ds';

import { CountLabel } from './CountLabel';

export interface NavigationTab {
  label: string;
  count?: number;
  onClick?: () => void;
}

interface Props {
  tabs: NavigationTab[];
  defaultActive?: number;
  css?: CSS;
  buttonCss?: CSS;
  activeButtonCss?: CSS;
  counterCss?: CSS;
  isLoading?: boolean;
}

const activeTabStyle: CSS = {
  background: designTokens.colorPaletteWhite,
  color: designTokens.colorBackgroundTopNav,
};

export const NavigationTabs = ({
  tabs,
  defaultActive = 0,
  css,
  buttonCss,
  activeButtonCss,
  counterCss,
  isLoading,
}: Props) => {
  const [activeTab, setActiveTab] = useState(defaultActive);

  useEffect(() => setActiveTab(defaultActive), [defaultActive]);

  return (
    <Flex
      align="center"
      css={{
        backgroundColor: 'rgba(9, 21, 33, 0.1)',
        borderColor: 'rgba(9, 21, 33, 0.1)',
        borderRadius: '20px',
        borderStyle: 'solid',
        borderWidth: '1px',
        padding: 1,
        gap: '1px',
        maxHeight: 50,
        alignSelf: 'center',
        ...css,
      }}
    >
      {tabs.map(({ label, count, onClick }, index) => {
        const isActive = activeTab === index;
        return (
          <Button
            key={index}
            variant="tertiary"
            size="small"
            aria-checked={isActive}
            css={{
              backgroundColor: 'transparent',
              color: designTokens.colorPaletteWhite,
              justifyContent: 'center',
              borderRadius: '20px',
              minWidth: 120,
              ...(isActive && activeTabStyle),
              '&:focus:after': {
                boxShadow: 'none',
                outline: 'none',
              },
              ...buttonCss,
              ...(isActive && activeButtonCss),
            }}
            onPress={() => {
              setActiveTab(index);
              onClick?.();
            }}
            startIcon={
              isLoading || !!count ? (
                <CountLabel
                  value={count || ''}
                  variant={isActive ? 'black' : 'darkGrey'}
                  css={counterCss}
                  isLoading={isLoading}
                />
              ) : undefined
            }
          >
            {label}
          </Button>
        );
      })}
    </Flex>
  );
};
